import React from 'react';
import { useState } from 'react'
import RecipeList from '../../../RecipePage/RecipeNavigator/RecipeList/RecipeList';
import RecipeSearch from "../../../RecipePage/RecipeNavigator/RecipeSearch/RecipeSearch"
import { useData } from "../../../DataContext/DataProvider"

function PlanRecipes({ planData, handleViewIngredients, isActive, activeDate }) {
    const [showRecipes, setShowRecipes] = useState(false);
    const [searchInput, setSearchInput] = useState("");
    const dataContext = useData();
    const recipes = dataContext.recipesData.recipes.filter((recipe) => {
        return recipe.Recipe_Name.toLocaleUpperCase().includes(searchInput.toLocaleUpperCase())
    });

    const handleAddNewRecipeClick = () => {
        setShowRecipes(!showRecipes);
    }

    const handleRecipeClick = (index) => {
        setShowRecipes(false);
        dataContext.planData.addNewRecipePlan(recipes[index], activeDate)
    }

    const deletePlanHandler = (e) => {
        dataContext.planData.handleDeletePlan(e.target.name)
    }

    const getStartOfToday = () => {
        const now = new Date().getTime();
        return now - now % 86400000
    }

    return(
        <div className={"recipe-plan-wrapper " + (isActive ? "active" : "inactive")} >
            <ul className="recipe-plan-names-container" style={{ height: (planData?.length * 10) + "%"}}>
                {planData?.map((element, index) => {
                    return (
                        <li className="recipe-plan-name" key={index}>
                            <span>{element.Recipe_Name}</span>
                            <button className="plan-ingredients-button button" name={element.Recipe_ID} onClick={() => { handleViewIngredients(index)} }>View Ingredients</button>
                            <button className="plan-delete-button button" name={element.Plan_ID} onClick={deletePlanHandler}>Remove</button>
                        </li>
                    )
                })}
            </ul>
            <div className="recipes-list-container">
                <div>
                    {activeDate >= new Date(getStartOfToday()) ? <button className="recipe-plan-add button" onClick={handleAddNewRecipeClick}>{showRecipes ? "Cancel" : "Add New Recipe Plan"}</button> : null}
                </div>
                {showRecipes ?
                    <div>
                        <RecipeSearch setSearchInput={setSearchInput} />
                        <RecipeList recipesArray={recipes} activateHandler={handleRecipeClick} />
                    </div>
                    : null}
            </div>
        </div>
    )
}

export default PlanRecipes